var map = {
	"./en": 82,
	"./en.js": 82,
	"./es": 84,
	"./es.js": 84,
	"./ru": 85,
	"./ru.js": 85
};
function webpackContext(req) {
	return __webpack_require__(webpackContextResolve(req));
};
function webpackContextResolve(req) {
	return map[req] || (function() { throw new Error("Cannot find module '" + req + "'.") }());
};
webpackContext.keys = function webpackContextKeys() {
	return Object.keys(map);
};
webpackContext.resolve = webpackContextResolve;
module.exports = webpackContext;
webpackContext.id = 83;



/*****************
 ** WEBPACK FOOTER
 ** ./~/validatorjs/src/lang ^\.\/.*$
 ** module id = 83
 ** module chunks = 0
 **/